var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M1.93934 12.9394C1.35355 13.5252 1.35355 14.4749 1.93934 15.0607C2.52513 15.6465 3.47487 15.6465 4.06066 15.0607L1.93934 12.9394ZM16.5 2.00003C16.5 1.1716 15.8284 0.50003 15 0.500031L1.5 0.50003C0.671573 0.50003 5.24154e-07 1.1716 8.61329e-07 2.00003C1.1985e-06 2.82846 0.671574 3.50003 1.5 3.50003H13.5V15.5C13.5 16.3285 14.1716 17 15 17C15.8284 17 16.5 16.3285 16.5 15.5L16.5 2.00003ZM4.06066 15.0607L16.0607 3.06069L13.9393 0.93937L1.93934 12.9394L4.06066 15.0607Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8bcdcca03fd056de4ccd1141b8ed9e5c.svg";
export { ForwardRef as ReactComponent };